import { Button, Flex, Stack, Text, useToast } from '@chakra-ui/react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { COLORS } from '../../constant/colors';
import { useConnectionConfiguration } from '../hooks/useConnectionConfiguration';
import { useReliusSequenceIds } from '../hooks/useGetReliusConfiguration';
import { useUpdateReliusConfiguration } from '../hooks/useUpdateReliusConfiguration';
import { FlatfileRequestsTable } from './FlatfileRequestsTable';
import { RetirementConfigurationModal } from './RetirementConfigurationModal';

export const RetirementIntegrations = () => {
  return (
    <Stack w={'100%'} gap={4}>
      <Flex
        width={'100%'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Flex
          dir="row"
          alignItems={'center'}
          justifyContent={'space-between'}
          width={'100%'}
        >
          <Text fontWeight={500} fontSize={'16px'}>
            File History
          </Text>
          <RetirementConfigurationModal />
        </Flex>
      </Flex>
      <FlatfileRequestsTable />
    </Stack>
  );
};
